import { render, staticRenderFns } from "./BlogLayoutHeader.vue?vue&type=template&id=30d2c0fd&"
import script from "./BlogLayoutHeader.vue?vue&type=script&lang=js&"
export * from "./BlogLayoutHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CImage: require('@chakra-ui/vue').CImage, CFlex: require('@chakra-ui/vue').CFlex, CPseudoBox: require('@chakra-ui/vue').CPseudoBox})
